
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","viewBox":"3 2.5 28 28","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M20.81 22.406h-7.617"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M12.847 22.052a7.203 7.203 0 118.303.003c-.336.224-.54.598-.549 1.002v3.322A3 3 0 0117.6 29.38h-1.2a3.001 3.001 0 01-3.002-3.001v-3.317a1.245 1.245 0 00-.551-1.01z"}}),_c('path',{attrs:{"d":"M26.019 7.605l-.902.902M8.882 24.742l-.902.902M29.755 16.625h-1.276M5.52 16.625H4.245M26.019 25.644l-.902-.902M8.882 8.507l-.902-.902M17 5.145V3.869"}})])])
          )
        }
      }
    